import React from 'react';
import getText from 'context/language/getText';
import { BodyLarge, BodyRegular } from 'components/common_v2/typography';
import { useStyles } from './styled';

export const PendingApproval = () => {
  const classes = useStyles();
  return (
    <div>
      <BodyLarge className={classes.warning}>
        {getText('banners.pendingApproval.title')}
      </BodyLarge>
      <BodyRegular className={classes.warning}>
        {getText('banners.pendingApproval.body')}
      </BodyRegular>
    </div>
  );
};
